import React from 'react';

// set the defaults
const GlobalContext = React.createContext({
  offline: false,
  setOffline: () => {}
});

export default GlobalContext;
